import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
    '@font-face': {
        fontFamily: 'imported',
    },
    root: {
        margin: '0'
    },
    defualt: {
        fontWeight: 500,
        fontSize: '1.125rem', //18px
        lineHeight: '1.562rem', //25px
    },
    // new
    os01: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(1.625rem , 5vw, 3.75rem)', //20px-60px
        lineHeight: 'clamp(2rem , 5vw, 4.25rem)', //32px-68px
        fontWeight: 700,
        color: theme.palette.orange,
    },
    os01A: {
        fontFamily: 'Object Sans',
        fontSize: '60px',
        lineHeight: '68px',
        fontWeight: 700,
        color: theme.palette.white,
    },
    os02: {
        fontFamily: 'Object Sans',
        fontSize: '1.625rem', //26px
        lineHeight: '1.75rem', //28px
        fontWeight: 700,
        color: theme.palette.blue,
    },
    os02A: {
        fontFamily: 'Object Sans',
        fontSize: '1.625rem', //26px
        lineHeight: '1.75rem', //28px
        fontWeight: 700,
        color: theme.palette.blue,
    },
    os02B: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(1rem , 5vw, 1.625rem)', //16px-26px
        lineHeight: 'clamp(1.5rem, 5vw, 1.75rem)', //24px-28px
        fontWeight: 700,
        color: theme.palette.blue,
    },
    os02C: {
        fontFamily: 'Object Sans',
        fontSize: '1.625rem',
        lineHeight: '1.75rem', 
        fontWeight: 700,
        color: theme.palette.blue,
    },
    os03: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(0.875rem, 0.5021rem + 1.8644vw, 2.25rem)',
    
        fontWeight: 700,
        color: theme.palette.blue,
        textAlign: 'center',
    },
    os03A: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(1.2rem , 5vw, 2.25rem)', //26px-36px
        lineHeight: 'clamp(1.750rem, 5vw, 2.5rem)', //28px-40px
        fontWeight: 700,
        color: theme.palette.white,
    },
    os03B: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(26px , 26px, 36px)', //20px-36px
        lineHeight: 'clamp(1.250rem , 5vw, 2.5rem)', //20px-40px
        fontWeight: 700,
        color: theme.palette.blue,
        textAlign: 'center',
    },
    os03C: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(1.5rem, 5vw, 2.25vw)', //25px-36px
        lineHeight: '2.5rem', //40px
        fontWeight: 700,
        color: theme.palette.black
    },
    os03D: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(16px , 26px, 46px)', //20px-36px
        lineHeight: 'clamp(40px , 40px, 40px)', //20px-40px
        fontWeight: 700,
        color: theme.palette.blue,
        textAlign: 'center',
    },
    os03E: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(26px , 5%, 46px)',
        lineHeight: 'clamp(28px , 40px, 40px)',
        fontWeight: 700,
        color: theme.palette.blue,
        textAlign: 'center',
    },
    os03F: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(26px , 5vw, 36px)', //20px-36px
        lineHeight: 'clamp(40px , 40px, 40px)', //20px-40px
        fontWeight: 700,
        color: theme.palette.blue,
        textAlign: 'center',
    },
    os03G: {
        fontFamily: 'Object Sans',
        fontSize: 'clamp(16px , 5vw, 36px)', //20px-36px
        lineHeight: 'clamp(26px , 5vw, 46px)', //20px-40px
        fontWeight: 700,
        color: theme.palette.blue,
        textAlign: 'center',
    },
    os04: {
        fontFamily: 'Object Sans',
        fontSize: '2.5rem', //40px
        lineHeight: '3.375rem', //54px
        fontWeight: 700,
        color: theme.palette.blue,
        textAlign: 'center'
    },
    os04A: {
        fontFamily: 'Object Sans',
        fontSize: '2.5rem', //40px
        lineHeight: '3.375rem', //54px
        fontWeight: 700,
        color: theme.palette.orange,
    },
    os05: {
        fontFamily: 'Object Sans',
        fontSize: '1.125rem', //18px
        lineHeight: '1.562rem', //25px
        fontWeight: 500,
        color: theme.palette.blue,
        textAlign: 'center'
    },
    os06: {
        fontFamily: 'Object Sans',
        fontSize: '1.625rem', //26px
        lineHeight: '1.75rem', //28px
        fontWeight: 700,
        color: theme.palette.white,
    },
    os07: {
        fontFamily: 'Object Sans',
        fontSize: '1.125rem', //18px
        lineHeight: '1.562rem', //25px
        fontWeight: 500,
        color: theme.palette.blue,
        textAlign: 'center'
    },
    os08: {
        fontFamily: 'Object Sans',
        fontSize: '2.25rem',
        fontWeight: 700,
        lineHeight: '2.5rem',
    },
    //
    pp01: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.2rem, 5vw, 1.5rem)', //10px-24px
        lineHeight: 'clamp(0.875rem, 5vw, 1.875rem)', //14px-30px
        fontWeight: 500,
        color: theme.palette.blue,
        textAlign: 'center'
    },
    pp01B: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.5rem, 5vw, 1.5rem)', //8px-24px
        lineHeight: 'clamp(0.75rem, 5vw, 2.5rem)', //16px-40px
        color: theme.palette.blue,
    },
    pp01C: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.5rem, 5vw, 1.5rem)', //8px-24px
        lineHeight: 'clamp(0.75rem, 5vw, 2.5rem)', //16px-40px
        fontWeight: '700',
        color: theme.palette.blue,
    },
    pp02: {
        fontFamily: 'Poppins',
        fontSize: '0.875rem', //14px
        lineHeight: '1.125rem', //18px
        color: theme.palette.blue,
        fontWeight: 400,
        textAlign: 'center'
    },
    pp02A: {
        fontFamily: 'Poppins',
        fontSize: '0.875rem', //14px
        lineHeight: '1.125rem', //18px
        fontWeight: 500,
        color: theme.palette.orange,
        textAlign: 'center'
    },
    pp02B: {
        fontFamily: 'Poppins Bold',
        fontSize: 'clamp(0.25rem, 5vw, 0.875rem)', //6px-14px
        lineHeight: 'clamp(1rem, 5vw, 2.5rem)', //16px-40px
        color: theme.palette.blue,
    },
    pp02C: {
        fontFamily: 'Poppins',
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
        color: theme.palette.blue,
        fontWeight: 400,
        textAlign: 'center'
    },
    pp03: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.875rem, 5vw, 1.5rem)', //14px-24px
        lineHeight: 'clamp(1.125rem, 5vw, 1.875rem)', //20px-30px
        fontWeight: 700,
        color: theme.palette.blue,
    },
    pp03A: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.875rem, 5vw, 1.5rem)', //14px-24px
        lineHeight: 'clamp(1.125rem, 5vw, 1.875rem)', //20px-30px
        fontWeight: 700,
        color: theme.palette.blue,
    },
    pp03B: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.875rem, 5vw, 1.5rem)', //14px-24px
        lineHeight: 'clamp(1.125rem, 5vw, 1.875rem)', //20px-30px
        fontWeight: 700,
        color: theme.palette.black,
    },
    pp04: {
        fontFamily: 'Poppins',
        fontSize: '1.125rem', //18px
        lineHeight: '1.550rem', //25px
        fontWeight: 500,
        color: theme.palette.white
    },
    pp04A: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.250rem, 5vw, 1.125rem)', //12px-18px
        // fontSize: 'clamp(0.250rem, 0.3034rem + 3.4783vw, 1.125rem)', //12px-18px
        lineHeight: 'clamp(1.550rem, 5vw, 1.125rem)', //18px-25px
        color: theme.palette.blue,
        textAlign: 'center'
    },
    pp04B: {
        fontFamily: 'Poppins',
        fontSize: '1.125rem', //18px
        lineHeight: '1.550rem', //25px
        fontWeight: 500,
        color: theme.palette.blue,
        textAlign: 'center'
    },
    pp05: {
        fontFamily: 'Poppins',
        fontSize: '0.625rem', //10px
        lineHeight: '0.875rem', //14px
        fontWeight: 500,
        color: theme.palette.blue,
        textAlign: 'center'
    },
    pp05A: {
        fontFamily: 'Poppins',
        fontSize: '0.625rem', //10px
        lineHeight: '0.875rem', //14px
        fontWeight: 500,
        color: theme.palette.orange,
        textAlign: 'center'
    },
    pp07: {
        fontFamily: 'Poppins',
        fontSize: '1rem', //16px
        lineHeight: '1.125rem', //18px
        fontWeight: 500,
        color: theme.palette.blueLightOne,
    },
    pp08: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.625rem, 5vw, 0.875rem)', //10px-14px
        lineHeight: 'clamp(0.875rem, 5vw, 1.125rem)', //14px-18px
        fontWeight: 500,
        color: theme.palette.blue,
    },
    pp09: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(1rem , 5vw, 1.250rem)', //16px-20px
        lineHeight: '2rem', //32px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp09A: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(1.250rem , 5vw, 1.250rem)', //20px-20px
        lineHeight: '2rem', //32px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp09B: {
        fontFamily: 'Poppins',
        fontSize: '1.25rem', //20px
        lineHeight: '2rem', //32px
        fontWeight: 700,
        color: theme.palette.blue,
    },
    pp09C: {
        fontFamily: 'Poppins',
        fontSize: '1.25rem', //20px
        lineHeight: '2rem', //32px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp09D: {
        fontFamily: 'Poppins',
        fontSize: '1rem', //16px
        lineHeight: '1.5rem', //24px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp10: {
        fontFamily: 'Poppins',
        fontSize: '1rem', //16px
        lineHeight: '1.250rem', //20px
        fontWeight: 400,
        color: theme.palette.orange,
    },
    pp10A: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.250rem , 5vw, 1rem)', //4px-16px
        lineHeight: 'clamp(0.500rem , 5vw, 1.250rem)', //8px-20px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp10B: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.250rem , 5vw, 1rem)', //4px-16px
        lineHeight: 'clamp(0.500rem , 5vw, 1.250rem)', //8px-20px
        fontWeight: 400,
        color: theme.palette.black,
    },
    pp11: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.250rem , 5vw, 1rem)', //4px-16px
        lineHeight: 'clamp(0.500rem , 5vw, 1.5rem)', //8px-24px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp12: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.75rem , 5vw, 1rem)', //12px-16px
        lineHeight: 'clamp(1rem, 5vw, 1.5rem)', //16px-24px
        fontWeight: 400,
        color: theme.palette.greyLightTwo,
    },
    pp12A: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(1rem , 5vw, 1rem)', //16px-16px
        lineHeight: 'clamp(1.5rem, 5vw, 1rem)', //24px-24px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp13: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.5rem , 5vw, 1rem)', //16px-16px
        lineHeight: 'clamp(1.5rem, 5vw, 1rem)', //24px-24px
        fontWeight: 400,
        color: theme.palette.blueLightFour,
    },
    pp13A: {
        fontFamily: 'Poppins',
        fontSize: 'clamp(0.5rem , 5vw, 1.250rem)', //16px-20px
        lineHeight: 'clamp(1.5rem, 5vw, 1.250rem)', //24px-24px
        fontWeight: 400,
        color: theme.palette.blueLightFour,
    },
    pp14: {
        fontFamily: 'Poppins',
        fontSize: '1.5rem', 
        lineHeight: '1.875rem', 
        fontWeight: 700,
        color: theme.palette.blue,
    },
    pp15: {
        fontFamily: 'Poppins',
        fontSize: '1.125rem', 
        lineHeight: '1.625rem', 
        fontWeight: 700,
        color: theme.palette.blue,
    },
    pp16: {
        fontFamily: 'Poppins',
        fontSize: '0.875rem', //14px
        lineHeight: '1rem', //16px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    pp16A: {
        fontFamily: 'Poppins',
        fontSize: '0.750rem', //12px
        lineHeight: '1rem', //16px
        fontWeight: 500,
        color: theme.palette.orange,
    },
    pp17: {
        fontFamily: 'Poppins',
        fontSize: '1rem', //16px
        lineHeight: '1.5rem', //24px
        fontWeight: 400,
        color: theme.palette.greyLightThree,
    },
    pp18: {
        fontFamily: 'Poppins',
        fontSize: '1rem', //16px
        lineHeight: '1.5rem', //24px
        fontWeight: 700,
        color: theme.palette.white,
    },
    pp19: {
        fontFamily: 'Poppins',
        fontSize: '1.5rem', //24px
        lineHeight: '1.5rem', //24px
        fontWeight: 400,
        color: theme.palette.blue,
    },
    '@media (max-width: 1000px)': {
        defualt: {
            fontWeight: 700,
            fontSize: '0.875rem', //14px
            lineHeight: '1.125rem', //18px
            margin: 0
        },

        os01A: {
            fontFamily: 'Object Sans',
            fontSize: '36px',
            lineHeight: '40px',
            fontWeight: 700,
            color: theme.palette.white,
        },
        os02: {
            fontFamily: 'Object Sans',
            fontSize: '1rem', //16px
            lineHeight: '1.75rem', //20px
            fontWeight: 700,
            color: theme.palette.blue,
        },
        os02A: {
            fontFamily: 'Object Sans',
            fontSize: '1.25rem', //20px
            lineHeight: '1.875rem', //30px
            fontWeight: 700,
            color: theme.palette.blue,
        },
        os04: {
            fontFamily: 'Object Sans',
            fontSize: '1.625rem', //26px
            lineHeight: '1.750rem', //25px
            fontWeight: 700,
            color: theme.palette.blue,
            textAlign: 'center'
        },
        os04A: {
            fontFamily: 'Object Sans',
            fontSize: '1.625rem', //26px
            lineHeight: '1.750rem', //25px
            fontWeight: 700,
            color: theme.palette.orange,
        },
        os05: {
            fontFamily: 'Poppins',
            fontSize: '0.750rem', //12px
            lineHeight: '1.125rem', //18px
            fontWeight: 500,
            color: theme.palette.blue,
            textAlign: 'center'
        },
        os06: {
            fontFamily: 'Poppins',
            fontSize: '1rem', //16px
            lineHeight: '1.75rem', //20px
            fontWeight: 700,
            color: theme.palette.blue,
            textAlign: 'center'
        },
        os07: {
            fontFamily: 'Poppins',
            fontSize: '0.875rem', //14px
            lineHeight: '1.125rem', //18px
            fontWeight: 700,
            color: theme.palette.blue,
            textAlign: 'center'
        },
        //

        pp02: {
            fontFamily: 'Poppins',
            fontSize: '0.625rem', //14px
            lineHeight: '1.125rem', //18px
            fontWeight: 500,
            color: theme.palette.blue,
            textAlign: 'center'
        },
        pp03A: {
            color: theme.palette.white,
        },
        pp04: {
            fontFamily: 'Poppins',
            fontSize: '0.875rem', //14px
            lineHeight: '1.125rem', //18px
            fontWeight: 500,
            color: theme.palette.white
        },
        pp04B: {
            fontFamily: 'Poppins',
            fontSize: '0.875rem', //14px
            lineHeight: '1.125rem', //18px
            fontWeight: 500,
            color: theme.palette.blue,
        },
        pp05: {
            fontFamily: 'Poppins',
            fontSize: '0.625rem', //10px
            lineHeight: '0.875rem', //14px
            fontWeight: 500,
            color: theme.palette.blue,
        },
        pp07: {
            fontFamily: 'Poppins',
            fontSize: '1rem', //16px
            lineHeight: '1.125rem', //18px
            fontWeight: 500,
            color: theme.palette.blueLightOne,
        },
    }
}))

function Typo({ children, variant, className, onClick }) {

    const classes = useStyles()

    const variantData =
    {
        'os01': classes.os01,
        'os01A': classes.os01A,
        'os02': classes.os02,
        'os02A': classes.os02A,
        'os02B': classes.os02B,
        'os02C': classes.os02C,
        'os03': classes.os03,
        'os03A': classes.os03A,
        'os03B': classes.os03B,
        'os03C': classes.os03C,
        'os03D': classes.os03D,
        'os03E': classes.os03E,
        'os03F': classes.os03F,
        'os03G': classes.os03G,
        'os04': classes.os04,
        'os04A': classes.os04A,
        'os05': classes.os05,
        'os06': classes.os06,
        'pp01': classes.pp01,
        'pp01B': classes.pp01B,
        'pp01C': classes.pp01C,
        'pp02': classes.pp02,
        'pp02A': classes.pp02A,
        'pp02B': classes.pp02B,
        'pp02C': classes.pp02C,
        'pp03': classes.pp03,
        'pp03A': classes.pp03A,
        'pp03B': classes.pp03B,
        'pp04': classes.pp04,
        'pp04A': classes.pp04A,
        'pp04B': classes.pp04B,
        'pp05': classes.pp05,
        'pp05A': classes.pp05A,
        'pp07': classes.pp07,
        'os07': classes.os07,
        'os08': classes.os08,
        'pp08': classes.pp08,
        'pp09': classes.pp09,
        'pp09A': classes.pp09A,
        'pp09B': classes.pp09B,
        'pp09C': classes.pp09C,
        'pp09D': classes.pp09D,
        'pp10': classes.pp10,
        'pp10A': classes.pp10A,
        'pp10B': classes.pp10B,
        'pp11': classes.pp11,
        'pp12': classes.pp12,
        'pp12A': classes.pp12A,
        'pp13': classes.pp13,
        'pp13A': classes.pp13A,
        'pp14': classes.pp14,
        'pp15': classes.pp15,
        'pp16': classes.pp16,
        'pp16A': classes.pp16A,
        'pp17': classes.pp17,
        'pp18': classes.pp18,
        'pp19': classes.pp19,
    }

    return (
        <span className={
            classNames(
                variantData[variant],
                classes.root,
                className)
        }
            onClick={onClick}
        >{children}</span>
    )
}
Typo.propTypes = {
    children: PropTypes.node,
    variant: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
}

export default Typo
